export const mapPositions = [
  ["LL.SM.3", "LL.SD.3", "LL.SD.1", "LL.SD.2"],
  [
    "FL.MST.2",
    "FL.ID.2",
    "LL.SAw.2",
    "LL.SAw.3",
    "LL.SM.2",
    "OT.Creat.2",
    "OT.PS.1",
  ],
  [
    "FL.MST.3",
    "FL.ID.1",
    "FL.MST.1",
    "LL.SM.1",
    "LL.SAw.1",
    "OT.Crit.3",
    "OT.Crit.1",
    "OT.PS.2",
  ],
  ["FL.MST.4", "FL.ID.3", "FL", "LL", "OT", "OT.Creat.1", "OT.Crit.2"],
  ["FK.SS.1", "FK.SS.2", "FK", "GC", "GC.IS.1", "GC.IS.2"],
  ["FK.AC.1", "FK.AC.2", "GC.SA.2", "GC.SA.1", "GC.IS.3"],
  ["FK.SS.4", "FK.SS.3", "GC.SAg.2", "GC.IS.4"],
  ["GC.SAg.1"],
];
